module.exports = __webpack_public_path__ + "static/media/404.ae2ccd00.png";